import { DataDownloadMessages } from '../types';

export const dataDownloadES: DataDownloadMessages = {
  'app.datadownload.checkbox.study_abroad': 'Estudiar en el extranjero',
  'app.datadownload.checkbox.additional_demographics_info': 'Datos demográficos adicionales',
  'app.datadownload.checkbox.remove_anonymous_user': 'Quitar usuarios anónimos',
}
